export enum ItemDisplay {
    HIDDEN          = 0,
    VISIBLE         = 1,
    GHOST_VISIBLE   = 2, // visible ghost - i.e. search show parents
    GHOST_HIDDEN    = 3  // invisible ghost - ???
}

export const ItemDisplayDict = {
    [ItemDisplay.VISIBLE]: 'Visible',
    [ItemDisplay.HIDDEN]: 'Hidden',
    [ItemDisplay.GHOST_VISIBLE]: 'Ghost Visible',
    [ItemDisplay.GHOST_HIDDEN]: 'Ghost Hidden'
}

// this full tree values ! ... i.e. children of children etc.
export type NumberOfChildren = {
    tasks               : number,
    tasksOpen           : number,   // for organization projects list only, otherwise no tasksOpen parameter present
    tasksTotal          : number,   // for organization projects list only, otherwise no tasksTotal parameter present
    projects            : number,
    projectsOpen        : number,
    completedSubItems   : number,   // this is NOT grand-grand... just children

    projectTasksOpen    : number,   // Ok this one is used in projects list & summarty  tasksOpen & tasksTotal come from server calculated
    projectTasksTotal   : number,   // Ok this one is used in projects list & summarty  tasksOpen & tasksTotal come from server calculated
}

export type ListItemCalculatedValues = {
    own?        : number
    children?   : number
    total?      : number
}

export type InitItemsCollectionOptions = {
    includeMultiProjectTasks: boolean
}